const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'id',
      type: "unvisible"
    },
    {
      name: 'type',
      label: 'Rodzaj dokumentu',
      column: 1,
      type: 'dictionary',
      dictionary: 'accountingDocumentType',
      mandatory: true,
    },
    {
      name: 'forPublic',
      label: 'Dostępny dla klienta',
      column: 1,
      type: 'boolean',
      defaultValue: 'true',
      mandatory: true,
    },

    {
      name: 'comment',
      label: 'Komentarz',
      column: 1,
      type: 'textarea',
    },
    {
      name: 'file',
      label: 'Plik',
      column: 1,
      type: 'file',
      single: true,
      fileFormats: ['PDF'],
      rows: 40,
      mandatory: true,
      privateView: true
    },
  ],
};

export default fields;
